<h1 class="title">Asset Grouping</h1>
<h5>Manage common assets</h5>
<acabim-datatable
    #dataTable
    [dataSources]="dataSources"
    [hasDetailView]="true">
</acabim-datatable>

<p-footer class="cas-action-buttons">
    <button type='button' class="cas-button-action" (click)="onAddAssetGroup()">Add asset group</button>
</p-footer>

<acabim-modal
        [display]="addAssetGroupModal"
        [title]="'Add asset group details'"
        (status)="setAddAssetGroupModal($event)"
        [footer]="false"
        width="60vw"
        fixHeight="60vh">
    <acabim-admin-add-asset-group
            *ngIf="addAssetGroupModal"
            actionType="add"
            actionButtonLabel="Add"
            (completed)="onAddCompletion($event)">
    </acabim-admin-add-asset-group>
</acabim-modal>

<ng-template [ngIf]="dataSources[0].showDetails">
    <acabim-modal
            [display]="true"
            [title]="'Edit asset group details'"
            (status)="setEditAssetGroupModal($event)"
            [footer]="false"
            width="60vw"
            fixHeight="60vh">
        <acabim-admin-update-asset-group
                [assetGroupDetails]="dataSources[0].detailData"
                (completed)="onEditCompletion($event)">
        </acabim-admin-update-asset-group>
    </acabim-modal>
</ng-template>
